import React from "react";
import PageWrapper, { PageHero } from "../components/PageWrapper";
import LeadForm from "../components/LeadForm";
import { ClipboardList, Users2, Settings2, Compass } from "lucide-react";

const PILLARS = [
  { icon: ClipboardList, title: "Logistics Management", desc: "Movement, accommodation, venue, and inventory orchestration." },
  { icon: Settings2, title: "Event Execution", desc: "On-ground execution for academic conferences, MUNs, and summits." },
  { icon: Users2, title: "Group Handling", desc: "Cohort coordination at any scale — institutional groups and delegations." },
  { icon: Compass, title: "Local Coordination", desc: "On-the-ground partners and protocol teams in destination cities." },
];

export default function DestinationManagementPage() {
  return (
    <PageWrapper testId="destination-management-page">
      <PageHero
        eyebrow="Destination Management"
        title="Your on-ground execution partner across global destinations."
        description="From Dubai and the wider Gulf to global institutional destinations — Destineze becomes the in-country execution arm for your travel and events."
        image="https://images.unsplash.com/photo-1751698186759-5bac83376c9f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwyfHxkdWJhaSUyMGFyY2hpdGVjdHVyZSUyMG1vZGVybiUyMGx1eHVyeXxlbnwwfHx8fDE3NzcyMjUwMzF8MA&ixlib=rb-4.1.0&q=85"
      />

      <section className="bg-white py-24 sm:py-28">
        <div className="max-w-[1280px] mx-auto px-5 sm:px-8 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="text-[11px] uppercase tracking-[0.22em] text-gold-500">
              Capabilities
            </div>
            <h2 className="mt-3 font-display text-3xl sm:text-4xl font-light text-navy tracking-tight">
              Operating the ground so your institution can focus on the agenda.
            </h2>
          </div>
          <div className="lg:col-span-7 lg:pt-3 grid grid-cols-1 sm:grid-cols-2 gap-6">
            {PILLARS.map((p, i) => (
              <div
                key={p.title}
                data-testid={`dm-pillar-${i}`}
                className="border border-slate-200 p-7"
              >
                <div className="h-10 w-10 bg-navy text-gold flex items-center justify-center">
                  <p.icon size={18} strokeWidth={1.5} />
                </div>
                <div className="mt-6 font-display text-lg text-navy">{p.title}</div>
                <div className="mt-2 text-sm text-slate-600 leading-relaxed">
                  {p.desc}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-navy text-white py-24 sm:py-28 relative overflow-hidden">
        <div className="absolute inset-0 bg-grid-navy opacity-30" />
        <div className="relative max-w-[1280px] mx-auto px-5 sm:px-8 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="text-[11px] uppercase tracking-[0.22em] text-gold">
              Plan with us
            </div>
            <h2 className="mt-3 font-display text-3xl sm:text-4xl font-light tracking-tight">
              Need an execution partner in Dubai or elsewhere?
            </h2>
            <p className="mt-6 text-white/70 leading-relaxed max-w-md">
              Tell us about your delegation, conference, or programme. We'll
              propose an execution structure tailored to your destination.
            </p>
          </div>
          <div className="lg:col-span-7">
            <LeadForm
              inquiryType="general"
              variant="dark"
              testIdPrefix="dm-lead-form"
              title="Engage our destination team"
              subtitle="Share your context. Our regional team will respond shortly."
            />
          </div>
        </div>
      </section>
    </PageWrapper>
  );
}
